export enum SmokingStatus {
  YES = 'yes',
  NO = 'no',
}

export enum WorkingStatus {
  YES = 'yes',
  NO = 'no',
}

export interface BackgroundInfoForm {
  dateOfBirth: string;
  monthlyIncome: number | undefined;
  debt: number | undefined;
  children: number;
  smokingStatus: SmokingStatus | null;
  workingStatus: WorkingStatus | null;
}
